import type { ButtonProps } from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import * as React from 'react';

import Icon from './Icon';

export type CloseButtonProps = ButtonProps;

const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(
  function CloseButton(props, ref) {
    return (
      <ChakraIconButton
        variant="ghost"
        aria-label="Close"
        bg="transparent"
        border="none"
        color="white"
        tabIndex={-1} // Make close buttons non-tabbable
        ref={ref}
        {...props}
      >
        {props.children ?? <Icon icon="close" fontSize="md" />}
      </ChakraIconButton>
    );
  }
);

export default CloseButton;
